module.exports = __webpack_public_path__ + "static/media/status-confirmation.44d45a74.svg";